import clsx from 'clsx';

interface SidebarIconButtonProps {
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  tooltip?: string;
}

export function SidebarIconButton({ icon, isActive, onClick, tooltip }: SidebarIconButtonProps) {
  return (
    <button
      onClick={onClick}
      title={tooltip}
      className={clsx(
        'p-2 rounded-md transition-colors',
        isActive
          ? 'bg-accent-violet-dim text-accent-violet'
          : 'text-text-quaternary hover:bg-surface-hover hover:text-text-tertiary'
      )}
    >
      {icon}
    </button>
  );
}
